import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * ForgotPassword — password reset is now handled natively by Clerk.
 * The Clerk SignIn component on /auth includes a "Forgot password?" link
 * that launches Clerk's built-in reset flow.
 *
 * Any old bookmark/link to /forgot-password or /reset-password just gets
 * redirected to /auth so the user can use the Clerk UI.
 */
export default function ForgotPassword() {
  const nav = useNavigate();

  useEffect(() => {
    nav("/auth", { replace: true });
  }, [nav]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 text-[#14C8B0] animate-spin" />
    </div>
  );
}
